import { useMutation, useQueryClient } from '@tanstack/react-query';
import { settingApi } from '../services/setting.service';
// import { useAuth } from '@/app/providers/AuthProvider';

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();
    // const { initializeAuth } = useAuth();

    return useMutation({
        mutationKey: ["updateProfile"],
        mutationFn: settingApi.updateProfile,
        onSuccess: () => {
            // initializeAuth();
            queryClient.invalidateQueries({ queryKey: ["user"] });
        },
    });
};

export const useUpdateAvatar = () => {
    const queryClient = useQueryClient();
    // const { initializeAuth } = useAuth();

    return useMutation({
        mutationFn: settingApi.updateAvatar,
        onSuccess: () => {
            // initializeAuth();
            queryClient.invalidateQueries({ queryKey: ["user"] });
        },
    });
};